module.exports = __webpack_public_path__ + "img/volume_down_icon.9dd4cd91.svg";